export const LISTE_PRODUITS_ACHAT = {
  title: 'Liste des produits d\'achat',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste produits d\'achat',
  },
  actions: {
    search: 'Rechercher',
    add: 'Nouveau produit',
    edit: 'Modifier',
    delete: 'Supprimer',
    desarchiver: 'Désarchiver',
    archiver: 'Archiver',
    filtre: 'Filtre',
  },
  tabs: {
    libelle: 'Libellé',
    type: 'Type',
    reference: 'Référence',
    societe: 'Société',
    actif: 'Archivé',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    categorie: 'Liste des types de produits',
    actif: 'Actif',
    yes: 'Oui',
    no: 'Non',
    societe: 'Societé',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  archivage: {
    archiver: 'Etes-vous sûr de vouloir archiver ce produit ?',
    desarchiver: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    sucessArchivage: 'Produit archivé avec succès',
    successDesarchivage: 'Produit désarchivé avec succès',
  },
};
export const PRODUIT_IMPRESSION_AFFICHE = {
  title: 'Détail impression affiche {libelle}',
  tva: 'TVA:',
  prixUnitaire: 'Prix unitaire:',
  numero: 'N° ',
  quantites: 'Quantité:',
  agence: 'Agence :',
  produit: 'Produit',
  pourcentage: '%',
  renouvelable: 'Renouvelable:',
  archivage: {
    action: 'Archiver',
    title: 'Etes-vous sûr de vouloir archiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitArchiver: 'Produit impression affiche archivé avec succès',
  },
  desarchivage: {
    action: 'Désarchiver',
    title: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
    yes: 'Oui',
    no: 'Non',
    produitArchiver: 'Produit impression affiche désarchivé avec succès',
  },
  libelleProduitForLogo: 'Produit impression affiche {ref}',
  societe: 'Société :',
  categorieOperation: 'Catégorie opération :',
  stockable: 'Stockable :',
};
